import { Field } from 'formik';

import { BaseSelect } from '../BaseSelect/BaseSelect';

export const SelectField = ({
  name,
  label,
  options,
  customKeys = { label: 'name', value: 'id' },
  placeholder = '',
  popupClassName = '',
  allowClear = false,
  valueType = null,
  multiple = false,
  getPopupContainer = null,
}) => (
  <Field
    component={BaseSelect}
    name={name}
    label={label}
    placeholder={placeholder}
    selectOptions={options}
    customKeys={customKeys}
    data-testid={name}
    classNames={{ popup: { root: popupClassName || name } }}
    allowClear={allowClear}
    valueType={valueType}
    popupMatchSelectWidth={false}
    mode={multiple ? 'multiple' : 'default'}
    getPopupContainer={getPopupContainer}
  />
);

export default SelectField;
